'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { serializeSidebarCollapsedPreference, serializeSidebarWidthPreference } from './sidebar-preference';
type SidebarPreferenceContextValue = {
  collapsed: boolean;
  persistCollapsed: (collapsed: boolean) => void;
  widthPx: number;
  persistWidth: (widthPx: number) => void;
};
const SidebarPreferenceContext = createContext<SidebarPreferenceContextValue | null>(null);
type SidebarPreferenceProviderProps = {
  children: React.ReactNode;
  initialCollapsed: boolean;
  initialWidthPx: number;
};
export function SidebarPreferenceProvider(t0) {
  const $ = _c(8);
  const {
    children,
    initialCollapsed,
    initialWidthPx
  } = t0;
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  const [widthPx, setWidthPx] = useState(initialWidthPx);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = nextCollapsed => {
      try {
        document.cookie = serializeSidebarCollapsedPreference(nextCollapsed, window.location.protocol === "https:");
      } catch {}
      setCollapsed(nextCollapsed);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const persistCollapsed = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = nextWidthPx => {
      try {
        document.cookie = serializeSidebarWidthPreference(nextWidthPx, window.location.protocol === "https:");
      } catch {}
      setWidthPx(nextWidthPx);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const persistWidth = t2;
  let t3;
  if ($[2] !== collapsed || $[3] !== widthPx) {
    t3 = {
      collapsed,
      persistCollapsed,
      widthPx,
      persistWidth
    };
    $[2] = collapsed;
    $[3] = widthPx;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const value = t3;
  let t4;
  if ($[5] !== children || $[6] !== value) {
    t4 = <SidebarPreferenceContext.Provider value={value}>{children}</SidebarPreferenceContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export function useSidebarPreference() {
  const context = useContext(SidebarPreferenceContext);
  if (context == null) {
    throw new Error("useSidebarPreference must be used within SidebarPreferenceProvider");
  }
  return context;
}